import { FC } from 'react'
import Swal from 'sweetalert2'
import {
  IconPaths,
  ModalSize,
  showAlert,
  showAlertLoading,
  showConfirmAlert,
} from '../../../../../../../_metronic/helpers'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { ErrosVinculos } from '../../../components/ErrosVinculos'
import { FeriadoList } from '../../../core/_models'
import { deleteFeriado, getFeriadoById } from '../../../core/_requests'
import { MENSAGEM_FALHA_GENERICA, extrairErrosValidacao } from '../../../core/escalaHelpers'
import { usePermissoesFeriado } from '../../../core/usePermissoesFeriado'
import { FeriadoFormModal } from '../../components/FeriadoFormModal'
import { useQueryResponse } from '../../core/QueryResponseProvider'

type Props = {
  feriado: FeriadoList
}

export const FeriadosActionsCell: FC<Props> = ({ feriado }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  // `Feriado:update`/`:delete` são só de SUPER_ADMIN/ADMIN — sem eles estes
  // botões existiriam apenas para devolver 403 ao serem clicados.
  const { podeEscrever } = usePermissoesFeriado()

  const abrirEdicao = async () => {
    try {
      showAlertLoading()
      // `FeriadoList` não traz a empresa; o detalhe (`FeriadoView`) traz.
      const detalhe = await getFeriadoById(feriado.id)
      Swal.close()
      showModal({
        title: `Editar feriado — ${detalhe.nome}`,
        size: ModalSize.Large,
        content: <FeriadoFormModal feriado={detalhe} onSuccess={refetch} />,
      })
    } catch (error) {
      Swal.close()
      const erros = extrairErrosValidacao(error)
      showModal({
        title: 'Não foi possível abrir o feriado',
        size: ModalSize.Medium,
        content: (
          <ErrosVinculos
            titulo='A API recusou a consulta:'
            itens={erros.todas.length ? erros.todas : [erros.mensagem ?? MENSAGEM_FALHA_GENERICA]}
          />
        ),
      })
    }
  }

  const excluir = async () => {
    const confirmado = await showConfirmAlert({
      title: 'Excluir o feriado?',
      text: `${feriado.nome} deixará de bloquear a agenda a partir de agora.`,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmado) return

    try {
      showAlertLoading()
      await deleteFeriado(feriado.id)
      Swal.close()
      showToast({ variant: 'success', title: `${feriado.nome} foi removido.` })
      refetch()
    } catch (error) {
      const erros = extrairErrosValidacao(error)
      showAlert({
        title: 'Não foi possível excluir',
        text: erros.todas[0] ?? erros.mensagem ?? MENSAGEM_FALHA_GENERICA,
        icon: 'error',
      })
    }
  }

  if (!podeEscrever) return null

  return (
    <RowActions
      itemName={`feriado ${feriado.nome}`}
      primaryAction={{ label: 'Editar', onClick: abrirEdicao, icon: IconPaths.Pen }}
      items={[{ label: 'Excluir', onClick: excluir, danger: true }]}
    />
  )
}
